/* eslint-disable no-mixed-operators */
function getTime(dateComponent) {
    const now = new Date();
    const time = (new Date(dateComponent.val()) - now + 1000) / 1000;
    const seconds = (`0${Math.floor(time % 60)}`).slice(-2);
    const minutes = (`0${Math.floor(time / 60 % 60)}`).slice(-2);
    const hours = (`0${Math.floor(time / 3600 % 24)}`).slice(-2);
    const days = Math.floor(time / (3600 * 24));

    return {
        seconds,
        minutes,
        hours,
        days,
        time,
    };
}

module.exports = {
    showTimer() {
        const timerUpdate = setInterval(() => {
            const dateComponent = $('#flash-sales-time-date');
            const secondsComponent = $('#flash-sales-time-seconds');
            const minutesComponent = $('#flash-sales-time-minutes');
            const hoursComponent = $('#flash-sales-time-hours');
            const daysComponent = $('#flash-sales-time-days');

            if (dateComponent && dateComponent.val()) {
                const currenTime = getTime(dateComponent);
                minutesComponent.text(currenTime.minutes);
                hoursComponent.text(currenTime.hours);
                daysComponent.text(currenTime.days);
                secondsComponent.text(currenTime.seconds);
                if (currenTime.time <= 1) {
                    clearInterval(timerUpdate);
                }
            } else {
                clearInterval(timerUpdate);
            }
        }, 1000);
    },
};
